import { render, staticRenderFns } from "./YapiKrediForm.vue?vue&type=template&id=63e74b7b"
import script from "./YapiKrediForm.vue?vue&type=script&lang=js"
export * from "./YapiKrediForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports